module.exports = __webpack_public_path__ + "img/flecha-hacia-arriba.70923445.png";